import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import scrollToTop from "../components/hooks/ScrollToTop";
import './css/templates.css';

// User Agreement component

const UserAgreement = () => {
  const { t } = useTranslation();

      useEffect(() => {
      scrollToTop();
    }, []);

    useEffect(()=>{
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'))
    },[])
    
  return (
    <div >
      <div className="page-wrapper">
        <Navbar />
      <div className="hero-wrapper hero-7 space" id="hero">
        <div className="container-space" >
          <div className="row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper">
            <div>
              <h3
                className="text-center links-heading item-heading-font "
                style={{ fontSize: "26px", color: "#ee7c2c" }}
              >
                {t("userAgreement")}
              </h3>
              <div className="mt-4">
                <p className="agreement-para">{t("independentSoftwarePartners")}</p>

                <p className="agreement-para">{t("applicantHereBy")}</p>

                <p className="agreement-para">
                  {t("uponAcceptance")}
                  <ol>
                    <li>{t("ceaseBusinessOperations")}</li>
                    <li>{t("dissolveAs")}</li>
                    <li>{t("terminateDistribution")}</li>
                  </ol>
                </p>

                <p className="agreement-para">{t("applicantHasRead")}</p>

                <p className="agreement-para">{t("applicantIsAnIndependent")}</p>

                <p className="agreement-para">{t("applicantWillNotProduce")}</p>

                <p className="agreement-para">{t("applicantHasTheDuty")}</p>

                <p className="agreement-para">{t("applicantUnderstands")}</p>

                <p className="agreement-para">{t("applicantAgreesThatCompensation")}</p>

                <p className="agreement-para">{t("anySaleOrAssignment")}</p>

                <p className="agreement-para">{t("theUndersignedHereBy")}</p>

                <p className="agreement-para">{t("venueAndJurisdiction")}</p>

                <p className="agreement-para">{t("noPurchaseOrInvestment")}</p>

                <p className="agreement-para">{t("youHaveTheRight")}</p>

                <p className="agreement-para">{t("youAreFreeToParticipate")}</p>

                <p className="agreement-para">{t("theCompanysGeneaLogy")}</p>

                <p className="agreement-para">{t("theCompanysFailure")}</p>

                <p className="agreement-para">{t("theCompanysWaiver")}</p>

                <p className="agreement-para">{t("theCompanyReserves")}</p>

                <p className="agreement-para">
                  <strong>{t("taxpayerIdentification")}</strong>
                  {t("ifYouAreAUnitedStates")}{" "}
                </p>

                <p className="agreement-para">{t("youMayBeRequired")}</p>

                <p className="agreement-para">{t("bySigningThisAgreement")}</p>

                <p className="agreement-para">{t("iSPAgrees")}</p>

                <p className="agreement-para">
                  {t("toTheMaximumExtent")}
                  <ul>
                    <li>{t("myOrAnyOtherISP")}</li>
                    <li>{t("thePromotionAndOperation")}</li>
                    <li>{t("anyIncorrectData")}</li>
                    <li>{t("myOrAnyOtherISP's")}</li>
                    <li>{t("awardsArising")}</li>
                  </ul>
                </p>

                <p className="agreement-para">{t("theCompanyGrants")}</p>

                <p className="agreement-para">{t("ifAISPWishes")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
    </div>
  );
};

export default UserAgreement;
